import { Category } from 'app/types/catalogue/category'

export const category1: Category = {
    id: 1,
    name: 'Industriel',
    priority: 1,
}

export const category2: Category = {
    id: 2,
    name: 'Sandwicherie',
    priority: 1,
}

export const category3: Category = {
    id: 3,
    name: 'Boulangerie',
    priority: 1,
}

export const category4: Category = {
    id: 4,
    name: 'Grande surface',
    priority: 1,
}

export const category5: Category = {
    id: 5,
    name: 'Administration publique',
    priority: 1,
}

export const category6: Category = {
    id: 6,
    name: 'Restaurant',
    priority: 1,
}

export const category7: Category = {
    id: 7,
    name: 'Traiteur',
    priority: 1,
}
